import { ModifyQuestionTranslationText, fillSentenceWord } from "../../i18n/TanslationHelper";
import store from "../../redux";
import moment from "moment";
import "moment/locale/nl"; // Import Dutch locale for moment.js

const getChatQuestions = ({
    T,
    index,
    to = '',
    from = '',
    travelers = '',
    infants = '',
    leaveTime = '',
    nightCount = '',
    stayOnly = false,
}) => {
    const state = store.getState();
    const loginconfig = state.loginconfig;
    // The departure-date questions (3 and 10) name the date by product: a stay only
    // has no flight, so the guest arrives rather than departs.
    const depart_type = T(stayOnly ? 'Chat:Chat_Bot_Type_Arrive' : 'Chat:Chat_Bot_Type_Depart');
    // The traveller questions (2, 5, 6, 8 and 9) name the trip the same way: a package
    // is "flying", a stay only is "travelling". T leaves {{travel_type}} untouched, so
    // fillSentenceWord fills it in and capitalises it where it starts the sentence.
    const travel_type = T(stayOnly ? 'Chat:Chat_Bot_Travelling_Word' : 'Chat:Chat_Bot_Flying_Word');

    const questions = [
        T('Chat:Chat_Bot_Question_Where_Want_To_Go'), // 0
        T('Chat:Chat_Bot_Question_From_Airport'), // 1
        fillSentenceWord(T('Chat:Chat_Bot_Question_Traveler_Count'), 'travel_type', travel_type), // 2
        T('Chat:Chat_Bot_Question_When_Leave', { depart_type: depart_type }), // 3
        T('Chat:Chat_Bot_Question_How_Many_Nights'), // 4
        fillSentenceWord(T('Chat:Chat_Bot_Question_Still_From_Airport', { from: from }), 'travel_type', travel_type), // 5
        ModifyQuestionTranslationText({
            message: fillSentenceWord(
                T('Chat:Chat_Bot_Question_Still_Travelers_Count', { travelers: travelers }),
                'travel_type',
                travel_type,
            ),
            params: {
                travelers: travelers,
            },
            language: loginconfig?.locale?.short,
        }), // 6
        T('Chat:Chat_Bot_Question_Surprise_Where_Want_To_Go'), // 7
        fillSentenceWord(T('Chat:Chat_Bot_Baby_Traveler_Count'), 'travel_type', travel_type), // 8
        ModifyQuestionTranslationText({
            message: fillSentenceWord(
                T('Chat:Chat_Bot_Previous_Baby_Travelers_Count', { infants: infants }),
                'travel_type',
                travel_type,
            ),
            params: {
                infants: infants,
            },
            language: loginconfig?.locale?.short,
        }), // 9
        (() => {
            // Re-format leaveTime with the current locale
            let formattedLeaveTime = leaveTime;
            if (leaveTime) {
                const momentLocale = loginconfig?.locale?.code ? loginconfig.locale.code.split('_')[0].toLowerCase() : 'en';
                // Try parsing with current locale first, then fallback to English
                let parsedDate = moment(leaveTime, ["DD MMMM YYYY", "DD MMMM", "MMMM DD YYYY", "MMMM DD", moment.ISO_8601], momentLocale);

                if (!parsedDate.isValid()) {
                    // Try parsing with English locale if current locale fails
                    parsedDate = moment(leaveTime, ["DD MMMM YYYY", "DD MMMM", "MMMM DD YYYY", "MMMM DD", moment.ISO_8601], 'en');
                }

                formattedLeaveTime = parsedDate.isValid()
                    ? parsedDate.locale(momentLocale).format("DD MMMM YYYY")
                    : leaveTime; // Fallback to original if parsing fails
            }
            return T('Chat:Chat_Bot_Previous_When_Leave', {
                leaveTime: formattedLeaveTime,
                depart_type: depart_type,
            });
        })(), // 10
        T('Chat:Chat_Bot_Previous_Where_Want_To_Go', { to: to }), // 11
        T('Chat:Chat_Bot_Previous_How_Many_Nights', {
            nightCount: nightCount,
        }), // 12
        // t('chatPage:howMuchSpend'),
        T('Chat:Chat_Bot_How_Much_Spend'), // 13
        T("Chat:Chat_Bot_Helping_Greetings_Text"), // 14
        T("Chat:Chat_Bot_Add_Additional_Requests"), // 15
        T("Chat:Chat_Bot_Complete_Package_Or_Stay_Only"), // 16
    ];

    return questions[index];
};

export default getChatQuestions;
